/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Error_Tracking_DescInputs */

const en_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helps us fix bugs and improve stability (Sentry)`)
};

const de_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilft uns, Fehler zu beheben und die Stabilität zu verbessern (Sentry)`)
};

const fr_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous aide a corriger les bugs et ameliorer la stabilite (Sentry)`)
};

const es_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos ayuda a corregir errores y mejorar la estabilidad (Sentry)`)
};

const it_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci aiuta a correggere bug e migliorare la stabilita (Sentry)`)
};

const nl_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpt ons bugs op te lossen en de stabiliteit te verbeteren (Sentry)`)
};

const pl_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomaga nam naprawiac bledy i poprawiac stabilnosc (Sentry)`)
};

const fi_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auttaa meitä korjaamaan virheitä ja parantamaan vakautta (Sentry)`)
};

const da_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjaelper os med at rette fejl og forbedre stabiliteten (Sentry)`)
};

const sv_cookie_consent_error_tracking_desc = /** @type {(inputs: Cookie_Consent_Error_Tracking_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjalper oss att fixa buggar och forbattra stabiliteten (Sentry)`)
};

/**
* | output |
* | --- |
* | "Helps us fix bugs and improve stability (Sentry)" |
*
* @param {Cookie_Consent_Error_Tracking_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_error_tracking_desc = /** @type {((inputs?: Cookie_Consent_Error_Tracking_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Error_Tracking_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_error_tracking_desc(inputs)
	if (locale === "fr") return fr_cookie_consent_error_tracking_desc(inputs)
	if (locale === "es") return es_cookie_consent_error_tracking_desc(inputs)
	if (locale === "it") return it_cookie_consent_error_tracking_desc(inputs)
	if (locale === "nl") return nl_cookie_consent_error_tracking_desc(inputs)
	if (locale === "pl") return pl_cookie_consent_error_tracking_desc(inputs)
	if (locale === "fi") return fi_cookie_consent_error_tracking_desc(inputs)
	if (locale === "da") return da_cookie_consent_error_tracking_desc(inputs)
	if (locale === "sv") return sv_cookie_consent_error_tracking_desc(inputs)
	return en_cookie_consent_error_tracking_desc(inputs)
});